export const Y_MAP_LANGS = {
  '1': 'ru_RU',
  '2': 'en_US',
  default: 'en_US',
};
